import { FIELD_BIND_TYPE_ENUM, GANTT_ENTITY_VARIABLE_TYPE } from '@constants'

export const enhanceWithCommandVariables = (originalObj: any) => {
  const obj = JSON.parse(JSON.stringify(originalObj))

  if (!obj.resource && !obj.timeline) return obj

  // Функция для извлечения переменных с фильтрацией по targetId
  const extractVariables = (
    data: any[],
    targetId: string | undefined,
    type: GANTT_ENTITY_VARIABLE_TYPE
  ) => {
    const variables: any[] = []

    const processItems = (items: any[]) => {
      items?.forEach(item => {
        if (
          !item.pathArray?.[0]?.objectCode ||
          !item.value ||
          item.pathArray[0].objectCode !== targetId ||
          item.type !== FIELD_BIND_TYPE_ENUM.FIELD
        ) {
          return
        }

        const newVar = {
          bindType: 'field' as const,
          field: {
            field: item.title,
            pathStr: item.value,
            pathArray: item.pathArray,
          },
        }

        const isDuplicate = variables.some(
          v =>
            v.field.field === newVar.field.field &&
            JSON.stringify(v.field.pathArray) === JSON.stringify(newVar.field.pathArray)
        )

        if (!isDuplicate) {
          variables.push(newVar)
        }
      })
    }

    if (type === GANTT_ENTITY_VARIABLE_TYPE.ACTION) {
      data?.forEach(action => {
        action.actionField?.commands?.forEach((command: any) => {
          processItems(command.parameters || [])
          processItems(command.body || [])
        })
      })
    }

    // if (type === GANTT_ENTITY_VARIABLE_TYPE.TOOLTIP) {

    // }

    // if (type === GANTT_ENTITY_VARIABLE_TYPE.CONTEXT_MENU) {

    // }

    return variables
  }

  const allActions = [
    ...(obj.resource?.actions || []),
    ...(obj.timeline?.flatMap((t: any) => t.actions || []) || []),
  ]

  // const allTooltips = [

  // ]

  // const allContextMenus = [

  // ]

  const resourceId = obj.resource?.data?.id

  if (resourceId) {
    obj.resource.commandVariables = extractVariables(
      allActions,
      resourceId,
      GANTT_ENTITY_VARIABLE_TYPE.ACTION
    )
    // obj.resource.tooltipVariables = extractVariables([], resourceId, GANTT_ENTITY_VARIABLE_TYPE.TOOLTIP)
    // obj.resource.contextMenuVariables = extractVariables([], resourceId, GANTT_ENTITY_VARIABLE_TYPE.CONTEXT_MENU)
  }

  if (Array.isArray(obj.timeline)) {
    obj.timeline.forEach((timelineItem: any, index: number) => {
      const timelineId = timelineItem.data?.id

      if (timelineId && timelineItem.actions) {
        obj.timeline[index].commandVariables = extractVariables(
          allActions,
          timelineId,
          GANTT_ENTITY_VARIABLE_TYPE.ACTION
        )
        // obj.timeline[index].tooltipVariables = extractVariables([], timelineId, GANTT_ENTITY_VARIABLE_TYPE.TOOLTIP)
        // obj.timeline[index].contextMenuVariables = extractVariables([], timelineId, GANTT_ENTITY_VARIABLE_TYPE.CONTEXT_MENU)
      }
    })
  }

  return obj
}
